<template>
    <div>
        <v-container fluid class="pa-4">
            <v-row dense>

                <!-- INFO DIALOGS -->
                <v-col cols="12" class="pb-2">
                    <v-row align-center justify-center row fill-height>
                        <v-col cols="12">
                            <v-alert type="warning" prominent class="body-2 mb-0" :value="!userLocalizable">
                                This is non writable system variable and therefore cannot be dynamically profiled
                            </v-alert>
                            <v-alert type="info" prominent class="body-2 mb-0" :value="userLocalizable && !dynamicProfiling">
                                Enable dynamic profiling to automatically populate this this data
                                variable
                            </v-alert>
                            <v-alert type="success" class="body-2 mb-0" :value="userLocalizable && dynamicProfiling">
                                Dynamic profiling is enabled. Make sure this data variable is translated for all the
                                locales
                                you would like to support! If you would like to compensate your panelists for each
                                answered dynamic profiling question then you may do so in the Sub Panel settings.
                            </v-alert>
                        </v-col>
                    </v-row>
                </v-col>

                <!-- DYNAMIC PROFILING SETTINGS -->
                <v-col cols="12" v-if="userLocalizable">
                    <title-card title="Dynamically profile" help="edit-datavariables-dynamic-profiling">

                        <div class="d-flex">

                            <v-switch color="primary"
                                      label="When answer is missing"
                                      v-model="variable.dynamic_profiling_when_missing"
                                      class="align-self-center"
                                      @change="emit"
                                      hide-details
                                      style="width: 400px;"
                            ></v-switch>
                            <v-switch color="primary"
                                      label="Based on the answer's age"
                                      v-model="variable.dynamic_profiling_by_age"
                                      @change="emit"
                                      hide-details
                                      class="ml-10 align-self-center"
                                      style="width: 400px;"
                            ></v-switch>

                        </div>

                        <div class="d-flex align-self-center mt-14">

                            <v-fade-transition>
                                <v-slider
                                    v-model="variable.dynamic_profiling_priority"
                                    class="align-self-center"
                                    prepend-icon="mdi-priority-high"
                                    :min="1"
                                    :max="10"
                                    ticks
                                    hint="Question priority"
                                    persistent-hint
                                    @change="emit"
                                    thumb-label="always"
                                    style="max-width: 400px;"
                                ></v-slider>
                            </v-fade-transition>

                            <v-fade-transition>
                                <v-slider v-show="variable.dynamic_profiling_by_age"
                                          v-model="variable.dynamic_profiling_days"
                                          class="ml-10 align-self-center"
                                          prepend-icon="mdi-clock-time-four-outline"
                                          :min="1"
                                          :max="365"
                                          thumb-label="always"
                                          hint="Maximum age limit in days"
                                          persistent-hint
                                          @change="emit"
                                          style="max-width: 400px;"
                                ></v-slider>
                            </v-fade-transition>
                        </div>

                    </title-card>
                </v-col>

            </v-row>

        </v-container>

    </div>
</template>

<script>

import Json from 'vue-json-pretty';
import TitleCard from "../../../../components/UI/TitleCard";

export default {

    components: {
        Json,
        TitleCard,
    },

    props: {
        dataVariable: {
            type: Object | null,
            required: true,
        },
    },

    watch: {
        // Async loading watch
        dataVariable(variable) {
            // Deep clone
            this.variable = JSON.parse(JSON.stringify(variable));
        }
    },
    mounted() {
        // If user is coming from the list page (both props are populated)
        if (this.dataVariable) {
            this.variable = JSON.parse(JSON.stringify(this.dataVariable));
        }
    },
    data() {
        return {
            debug: false,
            variable: null,
        }
    },

    computed: {
        dynamicProfiling() {
            if (this.variable) {
                return this.variable.dynamic_profiling_by_age ||
                    this.variable.dynamic_profiling_when_missing;
            }
            return false;
        },
        userLocalizable() {
            if (this.variable) {
                return this.variable.user_localizable;
            }
            return false
        },
    },

    methods: {
        emit() {
            this.$emit('change', this.variable);
        }
    }
}
</script>
